import { Separator } from '@betterment/samba-react';

import { MajorPurchaseForm } from './MajorPurchaseForm';
import { MajorPurchaseTargetSection } from './MajorPurchaseTargetSection';

import { MajorPurchaseSettingsPurpose } from '../../../data';

type Props = {
  purpose: MajorPurchaseSettingsPurpose;
};

export const MajorPurchaseSettings = ({ purpose }: Props) => {
  return (
    <>
      <MajorPurchaseForm purpose={purpose} />
      <Separator />
      <MajorPurchaseTargetSection purpose={purpose} />
    </>
  );
};
